<template>
  <div class="product-link-icon"  :style="styles" :class="sizeClass">
    <slot></slot>
  </div>
</template>

<script>
  import { IconSettings } from '../../model';

  export default {
    name: 'IconComponent',
    props: {
      hovered: {
        type: Boolean,
        default: false,
      },
      active: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      product: {
        type: String,
        required: true,
      },
      variant: {
        type: String,
        default: 'normal',
      },
    },
    data() {
      return {
        mainColor: IconSettings[this.product].activeColor,
        activeBG: IconSettings[this.product].activeBackground,
        activeColor: '#fff',
        mainBG: '#fff',
        disabledColor: '#E6E6E6',
      };
    },
    computed: {
      sizeClass() {
        return this.variant === 'small' ? 'product-link-icon-small' : 'product-link-icon-normal';
      },
      color() {
        if (this.active) {
          return this.activeColor;
        }

        if (this.disabled) {
          return this.disabledColor;
        }

        return this.hovered ? this.activeColor : this.mainColor;
      },
      background() {
        if (this.active) {
          return this.activeBG;
        }

        if (this.disabled) {
          return this.mainBG;
        }

        return this.hovered ? this.activeBG : this.mainBG;
      },

      styles() {
        return {
          color: this.color,
          background: this.background,
        };
      },
    },
  };
</script>

<style>
  .product-link-icon {
    box-shadow: var(--c360-shadow) !important;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.15s;
    flex-shrink: 0;
  }
  .product-link-icon-normal {
    width: 48px;
    height: 48px;
    border-radius: 10px;
  }

  .product-link-icon-normal svg {
    width: 32px;
    height: 32px;
  }
  
  .product-link-icon-small{
    width: 28px;
    height: 28px;
    border-radius: 4px;
  }
  
  .product-link-icon-small svg{
    width: 24px;
    height: 24px;
  }
</style>
